import {
    FETCH_USERS,
    FETCH_USERS_SUCCESS,
    FETCH_USERS_FAIL,
    CREATE_NEW_USER,
    CREATE_NEW_USER_SUCCESS,
    CREATE_NEW_USER_FAIL,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAIL,
    SET_USER_IS_ACTIVE,
    SET_USER_IS_ACTIVE_SUCCESS,
    SET_USER_IS_ACTIVE_FAIL,
    SET_USER_NEEDS_PASSWORD_RESET,
    SET_USER_NEEDS_PASSWORD_RESET_SUCCESS,
    SET_USER_NEEDS_PASSWORD_RESET_FAIL,
    SET_USER_IS_APPROVED,
    SET_USER_IS_APPROVED_SUCCESS,
    SET_USER_IS_APPROVED_FAIL,
    ADD_TAG_SUCCESS_AUTH_USER,
    ADD_TAG_FAIL_AUTH_USER,
    UPDATE_TAG_SUCCESS_AUTH_USER,
    UPDATE_TAG_FAIL_AUTH_USER,
    ADD_TAG_SUCCESS_USER,
    ADD_TAG_FAIL_USER,
    UPDATE_TAG_SUCCESS_USER,
    UPDATE_TAG_FAIL_USER,
    ADD_USER_ROLE,
    ADD_USER_ROLE_SUCCESS,
    ADD_USER_ROLE_FAIL,
    DELETE_USER_ROLE,
    DELETE_USER_ROLE_SUCCESS,
    DELETE_USER_ROLE_FAIL, SET_USER_EMAIL_VERIFIED, SET_USER_EMAIL_VERIFIED_SUCCESS, SET_USER_EMAIL_VERIFIED_FAIL,
} from 'constants/ActionTypes';
import {USERS_REINIT_STATE} from "../constants/ActionTypes";
import {addTag, updateTag} from "./Common";
import {bbIsObject} from "../util/bbHelpers";


/* ****************
Fetching users from the db
 *******************/
export const fetchUsers = () => {
    return {
        type: FETCH_USERS
    };
};

export const fetchUsersSuccess = (data) => {
    return {
        type: FETCH_USERS_SUCCESS,
        payload: data
    };
};

export const fetchUsersFail = (data) => {
    return {
        type: FETCH_USERS_FAIL,
        payload: data
    };
};

export const reinitUsersState = () => {
    console.log("Reinitializing Users State");
    return {
        type: USERS_REINIT_STATE
    };
};


/*  jfd*******************************
 *   /create a new user
     ********************************** */
export const createNewUserAction = (userInfo) => {
    return {
        type: CREATE_NEW_USER,
        payload: userInfo
    };
};

export const createNewUserSuccess = () => {
    console.log("createNewUserSuccess() has been called");
    return {
        type: CREATE_NEW_USER_SUCCESS
    };
};

export const createNewUserFail = () => {
    console.log("createNewUserFail() has been called");
    return {
        type: CREATE_NEW_USER_FAIL
    };
};

/*  jfd*******************************
 *   /delete user
     ********************************** */
export const deleteUserAction = (userInfo) => {
    return {
        type: DELETE_USER,
        payload: userInfo
    };
};

export const deleteUserSuccess = (userId) => {
    return {
        type: DELETE_USER_SUCCESS,
        payload: userId
    };
};

export const deleteUserFail = () => {
    return {
        type: DELETE_USER_FAIL
    };
};

/*  jfd*******************************
 *   /set is_active (disable or enable) user
     ********************************** */
export const setUserIsActiveAction = (userInfo) => {
    return {
        type: SET_USER_IS_ACTIVE,
        payload: userInfo
    };
};

export const setUserIsActiveSuccess = (userInfo) => {
    return {
        type: SET_USER_IS_ACTIVE_SUCCESS,
        payload: userInfo
    };
};

export const setUserIsActiveFail = () => {
    return {
        type: SET_USER_IS_ACTIVE_FAIL
    };
};

/*  sarahp*******************************
 *   /set is_activated (email is or isn't verified) user
     ********************************** */
export const setUserEmailVerified = (userId, newIsVerifiedStatus) => {
    console.log("This should be the aciton for setting user verifiaiton status, userId", userId, "newisVerifiedStatus", newIsVerifiedStatus)
    return {
        type: SET_USER_EMAIL_VERIFIED,
        payload:{
            userId,
            newIsVerifiedStatus
        }
    };
};

export const setUserEmailVerifiedSuccess = (data) => {
    return {
        type: SET_USER_EMAIL_VERIFIED_SUCCESS,
        payload: data
    };
};

export const setUserEmailVerifiedFail = (data) => {
    return {
        type: SET_USER_EMAIL_VERIFIED_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /set needs_password_reset (disable or enable) user
     ********************************** */
export const setUserNeedsPasswordResetAction = (userInfo) => {
    return {
        type: SET_USER_NEEDS_PASSWORD_RESET,
        payload: userInfo
    };
};

export const setUserNeedsPasswordResetSuccess = (userInfo) => {
    return {
        type: SET_USER_NEEDS_PASSWORD_RESET_SUCCESS,
        payload: userInfo
    };
};

export const setUserNeedsPasswordResetFail = () => {
    return {
        type: SET_USER_NEEDS_PASSWORD_RESET_FAIL
    };
};

/*  jfd*******************************
 *   /set is_approved (disable or enable) user
     ********************************** */
export const setUserIsApprovedAction = (userInfo) => {
    return {
        type: SET_USER_IS_APPROVED,
        payload: userInfo
    };
};

export const setUserIsApprovedSuccess = (userInfo) => {
    return {
        type: SET_USER_IS_APPROVED_SUCCESS,
        payload: userInfo
    };
};

export const setUserIsApprovedFail = () => {
    return {
        type: SET_USER_IS_APPROVED_FAIL
    };
};

/*  jfd**********22.Jan.24.11:51*****
 *  AuthUSER SETTINGS TAGS
     ********************** `--===<>==<>==C>-< */
// ****** SUCCESS AND FAIL FUNCTIONS ********
const addTagSuccessAuthUser = (data) => {
    return {
        type: ADD_TAG_SUCCESS_AUTH_USER,
        payload: data
    };
};

const addTagFailAuthUser = (data) => {
    return {
        type: ADD_TAG_FAIL_AUTH_USER,
        payload: data
    };
};

export const updateTagSuccessAuthUsers = (data) => {
    return {
        type: UPDATE_TAG_SUCCESS_AUTH_USER,
        payload: data
    };
};

export const updateTagFailAuthUsers = (data) => {
    return {
        type: UPDATE_TAG_FAIL_AUTH_USER,
        payload: data
    };
};

/*  jfd**********22.FEB.09.12:29*****
 *  USER SETTINGS TAGS
     ********************** `--===<>==<>==C>-< */
// ****** SUCCESS AND FAIL FUNCTIONS ********
const addTagSuccessUser = (data) => {
    return {
        type: ADD_TAG_SUCCESS_USER,
        payload: data
    };
};

const addTagFailUser = (data) => {
    return {
        type: ADD_TAG_FAIL_USER,
        payload: data
    };
};

export const updateTagSuccessUsers = (data) => {
    return {
        type: UPDATE_TAG_SUCCESS_USER,
        payload: data
    };
};

export const updateTagFailUsers = (data) => {
    return {
        type: UPDATE_TAG_FAIL_USER,
        payload: data
    };
};

// *****  ADD TAGS  ********

// Dark Mode
/**
 * Summary. enableDarkMode.
 *
 * Description. Adds an 'Out of Scope' tag to the given vector.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */
export const enableDarkMode = ( userId,) => {
    //Dark Mode is definition 51
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        51, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        null, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        true, //showUserMessage
        null, //affectedElementId
    );
};

// ******* UPDATE TAGS *****
/**
 * Summary. disableDarkMode.
 *
 * Description. Adds an 'Out of Scope' tag to the given vector.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */
export const disableDarkMode = ( tag,) => {
    //Dark Mode is definition 51
    if(bbIsObject(tag) && tag.definition.id === 51) {
        //TODO: verify that the tag is of type 44
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

// Custom Home Page tag definition id = 52
/**
 * Summary. addCustomHomePageTag.
 *
 * Description. Adds a Custom Home Page tag to user object.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */

export const addCustomHomePageTag = ( userId, homePageId, showUserMessage=true,) => {
    //Dark Mode is definition 51
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        52, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        homePageId, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        showUserMessage, //showUserMessage
        null, //affectedElementId
    );
};


/**
 * Summary. updateCustomHomePageTag.
 *
 * Description. Deactivates sn existing custom home page tag.
 *
 *  @param {object}   tag             tagId to update
 *
 * @return
 *
 * @example
 */

export const updateCustomHomePageTag = ( tag,) => {
    //Custom Home Page is id 52
    if(bbIsObject(tag) && tag.definition.id === 52) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

// User Early access tag is id 53
/**
 * Summary. addUserEarlyAccessTag.
 *
 * Description. Adds an Early Access User Tag.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */

export const enableUserEarlyAccess = ( userId, ) => {
    //User Early Access is id 53
    return addTag(
        addTagSuccessUser, //successAction
        addTagFailUser, //failAction
        53, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        null, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        true, //showUserMessage
        null, //affectedElementId
    );
};

/**
 * Summary. disableUserEarlyAccess.
 *
 * Description. Deactivates an existing user early access tag
 *
 *  @param {object}   tag             tag to disable
 *  @param {number}     userId  userId
 *
 * @return
 *
 * @example
 */
export const disableUserEarlyAccess = ( tag,) => {
    //user early access is id 53
    if(bbIsObject(tag) && tag.definition.id === 53) {
        return updateTag(
            updateTagSuccessUsers,
            updateTagFailUsers,
            tag.id,
            false,);
    } else {
        return updateTagFailUsers({
            tagId: tag.id
        })
    }
};

/**
 * Summary. enableBRLabs.
 *
 * Description. Adds a "BR Labs" tag to the authUser.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */
export const enableBRLabs = ( userId,) => {
    //brLabs is id 56
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        56, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        null, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        true, //showUserMessage
        null, //affectedElementId
    );
};

// ******* UPDATE TAGS *****
/**
 * Summary. disableBRLabs.
 *
 * Description. sets first BRLabs tag to is_active "false".
 *
 *  @param {object}   tag             tag to update
 *
 * @return
 *
 * @example
 */
export const disableBRLabs = ( tag,) => {
    //BRLabs is definition.id 56
    if(bbIsObject(tag) && tag.definition.id === 56) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

/**
 * Summary. addEmailFrequencyTag.
 *
 * Description. Adds an email frequency tag to the authUser.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */
export const addEmailFrequencyTag = ( userId, frequency, showUserMessage= true) => {
    //brLabs is id 55
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        57, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        frequency, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        showUserMessage, //showUserMessage
        null, //affectedElementId
    );
};

// ******* UPDATE TAGS *****
/**
 * Summary. updateEmailFrequencyTag.
 *
 * Description. sets first EmailFrequency tag to is_active "false".
 *
 *  @param {object}   tag             tag to update
 *
 * @return
 *
 * @example
 */
export const updateEmailFrequencyTag = ( tag, showUserMessage = true,) => {
    //BRLabs is definition.id 55
    if(bbIsObject(tag) && tag.definition.id === 57) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false,
            showUserMessage,);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};


/**
 * Summary. enableEmailNotifications.
 *
 * Description. Adds an email notifications tag to a user object.
 *
 *  @param {string}   userId             UserId to affect
 *
 * @return
 *
 * @example
 */
export const enableEmailNotifications = ( userId, showUserMessage = true) => {
    //brLabs is id 55
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        56, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        null, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        showUserMessage, //showUserMessage
        null, //affectedElementId
    );
};

// ******* UPDATE TAGS *****
/**
 * Summary. disableEmailNotifications.
 *
 * Description. sets first Email Notifications tag to is_active "false".
 *
 *  @param {object}   tag             tag to update
 *
 * @return
 *
 * @example
 */
export const disableEmailNotifications = ( tag,) => {
    //BRLabs is definition.id 55
    if(bbIsObject(tag) && tag.definition.id === 57) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

/**
 * Summary. addTagForToursTutorial,
 *
 * Description. disables tours for page indicated in details
 *
 * @param userId {number}
 * @param details {string}
 * @returns {type}
 */

export const addTagForToursTutorial = (userId, details) =>{
    //adding a tag disables a tour, indactes it has been seen
    // tutorial tours are tag id 61
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        61, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        details, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        false, //showUserMessage
        null, //affectedElementId
    );
}

/**
 * Summary. removeTagsForToursTutorial
 * Description. removes an existing new tutorial tag for a page, re-enabling that page's tours
 * @param tag
 * @returns {{payload, type: string}|{payload: {newIsActive: *, affectedElementId: *, successAction: function(): null, failAction: function(): null, tagId: *, customerId: *}, type: string}}
 */

export const removeTagsForToursTutorial = ( tag,) => {
    //removing a tag re-enables a tour
    //tutorial tours are tag id 61
    if(bbIsObject(tag) && tag.definition.id === 61) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

/**
 * Summmary. addTagForTOursTutorial
 * Description. adds a tag with a url in details indicates that the tour for that page/product has been viewed
 * @param userId
 * @param details
 * @returns {type}
 */

export const addTagForToursNew = (userId, details) =>{
    //adding a tag disables a tour, indicates it has been seen
    //what's new tours/ product tours, are tag id 62
    return addTag(
        addTagSuccessAuthUser, //successAction
        addTagFailAuthUser, //failAction
        62, //definitionId
        null, //entityId
        null, //targetId
        null, //vectorId
        null, //testedVectorId
        null, //identityid
        details, //details
        userId, //userId
        null, //customerId
        null, //subportfolioId
        false, //showUserMessage
        null, //affectedElementId
    );
}

/**
 * Summary. removeTagsForToursNew
 * Details. removing a tag re-enables a tour for that page
 *
 * @param tag
 * @returns {{payload, type: string}|{payload: {newIsActive: *, affectedElementId: *, successAction: function(): null, failAction: function(): null, tagId: *, customerId: *}, type: string}}
 */
export const removeTagsForToursNew = ( tag,) => {
    //removing a tag re-enables a tour
    //tutorial tours are tag id 62
    if(bbIsObject(tag) && tag.definition.id === 62) {
        return updateTag(
            updateTagSuccessAuthUsers,
            updateTagFailAuthUsers,
            tag.id,
            false);
    } else {
        return updateTagFailAuthUsers({
            tagId: tag.id
        })
    }
};

export const removeAllTagsForTutorialTours = (arrayOfTags) =>{
    if(Array.isArray(arrayOfTags)
        && arrayOfTags.filter((tag)=> tag.definition.id === 61)){

    }
}

/*  sarahp**********03.05.22*****
 *  ADD USER ROLES
     **********************  */

export const addUserRole = (data)=>{
    return{
        type: ADD_USER_ROLE,
        payload: data
    }
}

export const addUserRoleSuccess = (data)=>{
    return{
        type: ADD_USER_ROLE_SUCCESS,
        payload: data
    }
}

export const addUserRoleFail = (data)=>{
    return{
        type: ADD_USER_ROLE_FAIL,
        payload: data
    }
}

/*  sarahp**********03.05.22*****
 *  DELETE USER ROLES
     **********************  */

export const deleteUserRole = (data)=>{
    return{
        type: DELETE_USER_ROLE,
        payload: data
    }
}

export const deleteUserRoleSuccess = (data)=>{
    return{
        type: DELETE_USER_ROLE_SUCCESS,
        payload: data
    }
}

export const deleteUserRoleFail = (data)=>{
    return{
        type: DELETE_USER_ROLE_FAIL,
        payload: data
    }
}